<div class="camera-preview-area">
    @if (!error) {
        <video #videoEl autoplay playsinline class="camera-video"></video>
        <canvas #canvasEl hidden="true"></canvas>
        <div class="mt-2 d-flex gap-2">
            <button type="button" class="btn btn-primary" (click)="capture()">
                {{ 'CAMERA_MODAL_FORM_FILE_CAMERA_CAPTURE' | translate }}
            </button>
            <button type="button" class="btn btn-secondary" (click)="close()">
                {{ 'CAMERA_MODAL_FORM_FILE_CAMERA_CANCEL' | translate }}
            </button>
        </div>
    }
    @if (error) {
        <span class="text-danger d-block">{{ 'CAMERA_MODAL_FORM_FILE_CAMERA_ERROR' | translate }}</span>
        <button type="button" class="btn btn-secondary mt-2" (click)="close()">
            {{ 'CAMERA_MODAL_FORM_FILE_CAMERA_CANCEL' | translate }}
        </button>
    }
</div>
